/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Combo_Recipe_Type_ComboInputs */

const vi_combo_recipe_type_combo = /** @type {(inputs: Combo_Recipe_Type_ComboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combo`)
};

/**

* @param {Combo_Recipe_Type_ComboInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const combo_recipe_type_combo = /** @type {((inputs?: Combo_Recipe_Type_ComboInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Combo_Recipe_Type_ComboInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_combo_recipe_type_combo(inputs)
});